export default __webpack_public_path__ + "static/media/complementary--except-trams--g1.68209674.png";